import nb_NO from '../../date-picker/locale/nb_NO';
export default nb_NO;



// WEBPACK FOOTER //
// ./components/calendar/locale/nb_NO.tsx